var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{attrs:{"transparent":""}},[_c('template',{slot:"brand"},[_c('b-navbar-item',{attrs:{"tag":"router-link","to":{ path: '/invoices' }}},[_c('i',{class:_vm.$i18n.locale == 'en'
                        ? 'flaticon2-left-arrow'
                        : 'flaticon2-right-arrow'}),_c('span',{staticClass:"font-apercu",staticStyle:{"padding":"0 15px"}},[_vm._v(" "+_vm._s(_vm.$t("Back"))+" ")])])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }